import { Injectable } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';

import { combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';

import { AuthService } from '@auth0/auth0-angular';
import { Store } from '@ngrx/store';
import { routerNavigationAction } from '@ngrx/router-store';
import { Router } from '@angular/router';

@Injectable()
export class AppRouterEffects {
  constructor(
    actions$: Actions,
    store: Store,
    auth: AuthService,
    router: Router,
  ) {
    combineLatest([
      auth.isAuthenticated$,
      actions$.pipe(ofType(routerNavigationAction)),
    ])
      .pipe(
        filter(
          ([isAuthenticated, currentRoute]) =>
            !!isAuthenticated &&
            currentRoute?.payload?.event?.urlAfterRedirects === '/',
        ),
      )
      .subscribe(([_isAuthenticated, _currentRoute]) => {
        router.navigateByUrl('/home/dashboard');
      });
  }
}
